import { EmailListField, EmailListFieldProps } from '@components/email-field';
import { FieldMappingData } from '@components/text-editors/addons/field-mapping';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormEmailListFieldProps<T = unknown> = FormFieldProps<EmailListFieldProps, T> &
  FieldMappingData;

export function FormEmailListField<T>(props: FormEmailListFieldProps<T>) {
  const { validators = [] } = props;
  const formFieldProps = useFormField({
    ...props,
    validators: ['email', ...validators],
    valueType: 'field-mapping-list',
  });

  return <EmailListField {...props} {...formFieldProps} />;
}
